import ServiceDetail from "@/components/ServiceDetail";

const description = [
  "Genspire's Contract Staffing solutions help organizations access skilled professionals while maintaining the flexibility required to respond to changing workforce demands. Businesses may require additional talent for specific projects, temporary assignments, seasonal workloads, new initiatives, business expansion or specialized requirements — and contract staffing provides a practical way to scale the workforce according to operational needs.",
  "We begin by understanding the nature of the requirement, including the role, required skills, experience, project requirements and expected duration of the engagement. Our team then focuses on identifying professionals who match these requirements and can contribute effectively to the assignment.",
  "Contract staffing gives businesses greater workforce flexibility while reducing the need to commit immediately to long-term hiring for every requirement. It also helps organizations respond more efficiently when workforce requirements change over time. Genspire supports clients throughout the staffing process by identifying suitable professionals and facilitating the engagement in a structured manner.",
  "Whether the requirement is a short-term project, a temporary workforce increase or an evolving business need, our contract staffing solutions are designed to provide the flexibility your business requires — with professionals matched to assignments that align with their skills and experience.",
];

const steps = [
  { title: "Scope", text: "We define the role, skills, experience, project requirements, and expected duration of the engagement." },
  { title: "Identify", text: "Focused search for professionals who match the assignment and can contribute effectively from day one." },
  { title: "Engage", text: "Structured onboarding and engagement facilitation, handled cleanly and quickly." },
  { title: "Support", text: "Ongoing coordination through the assignment, adapting as your workforce needs change." },
];

const benefits = [
  "Workforce flexibility without immediate long-term hiring commitments",
  "Faster response to projects, seasonal workloads, and expansion",
  "Skilled professionals matched to the assignment's skills and duration",
  "A structured, dependable engagement process from scoping to support",
  "Scale your workforce up or down as operational needs evolve",
  "Reduced administrative and hiring overhead for internal teams",
];

export default function ContractStaffing() {
  return (
    <ServiceDetail
      headlineTop="Contract"
      headlineAccent="Staffing."
      tagline="Flexible talent for changing business needs."
      description={description}
      steps={steps}
      benefits={benefits}
      benefitsHeading="Benefits of Contract Staffing"
      submitLabel="Discuss Your Requirement"
      pageTestId="contract-page"
      ctaTitle="Discuss Your Staffing Requirement"
      ctaSub="Tell us what you're scaling towards — we'll shape the workforce around it."
    />
  );
}
